var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { LiveOutright, MiniOutright, AggregateCard } from "../../../components";
import * as MiniCardTypes from "../../../components/MiniEventCardTypes";
import * as CardTypes from "../../../components/EventCardTypes";
import { RenderPreliveOutright } from "../../../components/RenderComponents/RenderPreliveOutright";
var RenderCard = /** @class */ (function (_super) {
    __extends(RenderCard, _super);
    function RenderCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RenderCard.prototype.getCardType = function () {
        var ComponentTypeMap = {
            AggregateCard: AggregateCard,
            CardTypes: CardTypes,
            MiniCardTypes: MiniCardTypes,
            MiniOutright: MiniOutright,
            LiveOutright: LiveOutright,
            PreLiveOutright: RenderPreliveOutright
        };
        return this.props.event.cardType
            ? ComponentTypeMap[this.props.event.componentType][this.props.event.cardType]
            : ComponentTypeMap[this.props.event.componentType];
    };
    RenderCard.prototype.render = function () {
        var CardTypeComp = this.getCardType();
        return React.createElement(CardTypeComp, __assign({}, this.props));
    };
    return RenderCard;
}(React.PureComponent));
export { RenderCard };
//# sourceMappingURL=RenderCard.js.map